import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class AdminPagejs {

    constructor() {
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    async postRequest(e, action, controller, loadingId, successMessageId, failedMessageId, errorId, user, hash) {
        e.preventDefault();
        var that = this;
        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(failedMessageId);
        that.utilsjs.showById(loadingId);
        that.utilsjs.hideById(successMessageId);
        that.utilsjs.hideById(errorId);

        const formData = that.ajaxjs.serializeMultipleFileForm(e.target.id);
        const result = await that.ajaxjs.postForm(action + '?user=' + user + '&hash=' + hash, controller, formData);
        if (result === '201') {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(successMessageId);
            that.utilsjs.hideById(failedMessageId);
            that.utilsjs.hideById(errorId);
        } else {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.hideById(successMessageId);
            that.utilsjs.showById(errorId);
            that.utilsjs.changeInnerHtmlById(errorId, result)

        }
        button.disabled = false;
    }
}





// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/adminPage.js